<template>
    <Head title="Dashboard" />

    <AuthenticatedLayout>
        <div
            class="component-background-desktop component-background-mobile px-6 py-4 grid justify-items-center pt-[1vw] sm:pt-10"
        >
            <div class="pb:w-[69vw] mt-[4rem] grid gap-y-6">
                <WelcomeParticipant
                    :name="$page.props.auth.user.nickname"
                    :region="currentRegion?.region"
                    :subRegion="currentRegion?.subregion"
                />

                <UploadPhotosCard
                    v-if="canUploadPhotoInRegion"
                    :currentRegion="currentRegion"
                    @updateContest="openUploadPage($event)"
                />

                <SplideMainCarousel
                    v-if="bannersRotativoDesktop?.length"
                    class="sm:hidden"
                    :banners="bannersRotativoDesktop"
                />
                <SplideMainCarousel
                    v-if="bannersRotativoMobile?.length"
                    class="pb:hidden"
                    :banners="bannersRotativoMobile"
                    id="banner-mobile"
                />
                <div
                    class="grid xl:grid-cols-3 gap-x-7 grid-flow-col sm:grid-flow-row gap-y-4"
                >
                    <PanelGallery :isLoading="isLoadingPerformanceParticipantData"
                        :marketsAvailable="photoCount"
                        @requestPerformanceUpdate="fetchParticipantPersonalPerformance()" />
                    <RadialProgress :isLoading="isLoadingPerformanceTeamData"
                        :teamPerformance="teamPerformance"
                        @requestPerformanceUpdate="fetchParticipantTeamPerformance()" />
                    <Points
                        @changepoints="showModalChangePoints = true"
                        :points="
                            $page.props.auth.user.account
                                ? $page.props.auth.user.account.balance
                                : '0'
                        "
                        :lastUpdate="$page.props.auth.user.account?.updatedAt"
                        :isVisibleBalance="
                            $page.props.auth.user.isVisibleBalance
                        "
                    />
                </div>
                <div class="bg-white rounded-2xl p-4">
                    <h1 class="text-primary font-bold">Destaques do Mês</h1>
                    <div class="flex justify-start">
                        <a class="mb-3" href="/campaigns"
                            >Clique aqui e confira os destaques do mês</a
                        >
                        <Icon class="w-4" name="SetaDireita" />
                    </div>
                    <!-- <Carousel class="pb:hidden"/> -->
                    <a class="pb:grid pb:gap-x-6 pb:grid-cols-3 sm:hidden">
                        <LinkBanner
                            v-for="(banner, key) in getSpotlightBanner"
                            :key="key"
                            :banner="banner"
                        />
                    </a>
                    <SplideMainCarousel
                        v-if="getSpotlightBannerMobile?.length"
                        class="hidden sm:block"
                        :banners="getSpotlightBannerMobile"
                    />
                </div>
            </div>
        </div>
        <PopUpNotification
            v-for="item in popupList"
            :showModal="item.id"
            @closeModal="onCloseModal(item.id)"
            :notification="item.popup"
            :key="item.id"
        />
        <ModalNewRegulation
            :data="$page.props.auth.user.regulation"
            :showModal="$page.props.auth.user.showModalRegulation"
        />
        <ModalNewTerm
            :data="$page.props.auth.user.term"
            :showModal="$page.props.auth.user.showModalTerm"
            :message="$message"
        />
    </AuthenticatedLayout>
    <transition>
        <div
            v-if="showModalChangePoints"
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-primary rounded-[4px] w-2.5/12 px-4 py-4 leading-9 flex flex-col gap-y-4"
            >
                <button class="self-end" @click="showModalChangePoints = false">
                    <Icon name="Fechar" />
                </button>
                <img src="images/banner-troque-seus-pontos.jpeg" alt="" />
            </div>
        </div>
    </transition>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import EmbassadorProgressTable from "@/Components/EmbassadorProgressTable.vue";
import Score from "@/Components/Score.vue";
import PanelGallery from "@/Components/PanelGallery.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Points from "@/Components/UI/Dashboard/Points.vue";
import Ranking from "@/Components/UI/Dashboard/Ranking.vue";
import ModalNewRegulation from "@/Components/ModalNewRegulation.vue";
import ModalNewTerm from "@/Components/ModalNewTerm.vue";
import WelcomeParticipant from "@/Components/UI/Dashboard/WelcomeParticipant.vue";
import CarouselDesempenho from "@/Components/UI/Dashboard/CarouselDesempenho.vue";
import RadialProgress from "@/Components/UI/Dashboard/RadialProgress.vue";
import LinkBanner from "@/Components/UI/Dashboard/LinkBanner.vue";
import SplideMainCarousel from "@/Components/UI/Dashboard/SplideMainCarousel.vue";
import PopUpNotification from "@/Components/UI/Notification/PopUpNotification/index.vue";
import UploadPhotosCard from "@/Components/UI/Dashboard/UploadPhotosCard.vue";

export default {
    components: {
    AuthenticatedLayout,
    EmbassadorProgressTable,
    Score,
    Head,
    Icon,
    WelcomeParticipant,
    Points,
    PanelGallery,
    CarouselDesempenho,
    Ranking,
    LinkBanner,
    RadialProgress,
    ModalNewRegulation,
    ModalNewTerm,
    SplideMainCarousel,
    PopUpNotification,
    UploadPhotosCard,
},
    props: {
        user: Object,
        qualifiers: Object,
        currentRegion: Object,
        ranking: Object,
        teamPerformance: Object,
        photoCount: Number,
        banners: Object,
        popups: Object,
    },
    computed: {
        participantType() {
            return this.$page.props.auth.user.participant.type;
        },
        isMerchan() {
            return this.participantType === 'M';
        },
        isManager() {
            return this.jobTitle === 'GERENTE';
        },
        isDigi() {
            return this.$page.props.auth.user?.email?.includes('@digi.ag');
        },
        isAdmin() {
            return this.$page.props.auth.user?.participant?.role?.toLowerCase() == 'admin';
        },
        canUploadPhoto() {
            return this.isAdmin || this.isDigi || (this.isMerchan && !this.isManager);
        },
        canUploadPhotoInRegion() {
                return false; 
        },
        imagePath: function () {
            return "Centro-Norte.png";
        },
        getSpotlightBanner() {
            if (this.banners.bannerDestaque?.length > 0)
                return this.banners.bannerDestaque;

            return [];
        },
        getSpotlightBannerMobile() {
            if (this.banners.bannerDestaqueMobile?.length > 0)
                return this.banners.bannerDestaqueMobile;

            return [];
        },
        bannersRotativoMobile() {
            return this.banners.bannerRotativo?.filter((banner) =>
                banner?.alias?.includes("mobile")
            );
        },
        bannersRotativoDesktop() {
            return this.banners.bannerRotativo?.filter((banner) =>
                banner?.alias?.includes("desktop")
            );
        },
    },
    data() {
        return {
            popupList: this.popups,
            isLoadingPerformanceParticipantData: false,
            isLoadingPerformanceTeamData: false,
            showModalChangePoints: false,
            linksBanners: [
                {
                    //   title: "Resgatar",
                    //   text: "Seus pontos podem virar prêmios",
                    link: "/campaigns",
                    //   textButton: "Resgatar",
                    img: "images/incentivos-1.png",
                },
                {
                    //   title: "Regulamento",
                    //   text: "Entenda como funciona a campanha",
                    //   textButton: "Ler o Regulamento",
                    link: "/campaigns",
                    img: "images/incentivos-2.jpg",
                },
                {
                    //   title: "Produtos Participantes",
                    //   text: "Mantenha o foco nesses produtos",
                    //   textButton: "Conferir Produtos",
                    link: "/how-it-works",
                    img: "images/incentivos-3.jpg",
                },
            ],
            teamPerformance: this.teamPerformance,
            photoCount: this.photoCount,
        };
    },
    beforeCreate(){
        const scriptHotjar = document.createElement('script');
        scriptHotjar.type = 'text/javascript';
        scriptHotjar.innerHTML = `
            (function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:4972416,hjsv:6};
            a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;

        document.head.prepend(scriptHotjar);
    },
    methods: {
        async fetchParticipantPerformance() {
            const { data } = await axios.get(this.route('dashboard.performance'));

            this.teamPerformance = data.teamPerformance;
            this.photoCount = data.photoCount;
            this.isLoadingPerformanceData = false;
        },
        async fetchParticipantTeamPerformance() {
            this.isLoadingPerformanceTeamData = true;
            const { data } = await axios.get(this.route('dashboard.performance.team'));

            this.teamPerformance = data.teamPerformance;
            this.isLoadingPerformanceTeamData = false;
        },
        async fetchParticipantPersonalPerformance() {
            this.isLoadingPerformanceParticipantData = true;
            const { data } = await axios.get(this.route('dashboard.performance.participant'));

            this.photoCount = data.photoCount;
            this.isLoadingPerformanceParticipantData = false;
        },
        onCloseModal(popUpId) {
            this.popupList = this.popupList.filter((item) => item.id != popUpId);
        },
        openUploadPage(contestId) {
            this.$inertia.get(this.route('merchan.upload.index'), { contestId });
        },
    }
};
</script>
<style>
.grid-icon-template {
    grid-template-columns: min-content auto;
}
@media only screen and (min-width: 1141px) {
    .grid-cols-panel {
        grid-template-columns: 2fr 1fr;
    }
}
</style>
